import type { FaireProductEntity } from "../../entity_types/product";

export const p_8477yjjq65: FaireProductEntity = {
  token: "p_8477yjjq65",
  type: "product",
  name: "Women's Cable Knit 1/2 Zip & Tapered Pant Lounge Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/80a989cda79296c0fb9d31e23a6878d254d5b65128490bbdacd5d4038686cff5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/479fb2601ac194a152b12532c0516666533e537ac3ad16d9203bbdbd2a2b2891.jpeg",
    "https://cdn.faire.com/fastly/9fe6928b52019110d9d348cb8266001e26da25e23e34e2ab2688724485317469.jpeg",
    "https://cdn.faire.com/fastly/12992f9cb0ec6f91ab3b1bf6e0cf559ddcc4f519db880d015cab8c0e854e5644.png",
    "https://cdn.faire.com/fastly/268ef0a1d3dfd08c128bb8a549b4c0a10f4a7e57818928ba904627203cc012a7.jpeg",
    "https://cdn.faire.com/fastly/8d86b8976de0b582e2b390a761c2d654ecfc83536ec0c5b6abeb6dda348b6e48.jpeg",
    "https://cdn.faire.com/fastly/d4b7b5d4d6e1cdb54a4943e20230313072afc3005b88243935913cdf8355a7e5.jpeg",
    "https://cdn.faire.com/fastly/259280092c6e666d4605647f321318b812a85b5a4852628477f228558c4c731d.png",
    "https://cdn.faire.com/fastly/9bba5b074e0edc9706e36322d702bf75460d2ff275aebc876e55bcea3c79cd58.jpeg",
    "https://cdn.faire.com/fastly/3ddb09b1cfffdc6112424818dc58463bda83954d9c976295e6fcb9d72308e28a.jpeg",
    "https://cdn.faire.com/fastly/e2961a950c743217ae5c6f43ca19dc2e10457d0a2ebc98082e83b6ff625a1754.jpeg",
    "https://cdn.faire.com/fastly/fa073d79981c812b3234ebcce28a28fa7f28bfc2e89e7268344536bb4a45c35b.png",
    "https://cdn.faire.com/fastly/bfeb0e87312bda17e623b3f6daa48597c4ec3c145b1dfc3e521c0463702c50a0.jpeg",
    "https://cdn.faire.com/fastly/4af97217abe49c0b4d9cf88153a42358d17cb897099c2e4215519af39860d6d0.jpeg",
    "https://cdn.faire.com/fastly/dd624948dd7b526d3587061046ab8eb3f8bcb4caba2b61d93d82ad5faab6e129.jpeg",
    "https://cdn.faire.com/fastly/c93ab116000e9eef326251bbc76b8c49e74da89b24604d592e0a4c5b818f0a64.png"
  ],
  priceDollars: 80,
  description: "The relaxed 1/2 zip pullover offers versatile styling and easy layering, while the tapered pant creates a flattering silhouette that feels polished without sacrificing comfort. Plush, cozy, and effortlessly chic.\n\nFabrication:\nExperience the irresistible softness of our signature Marshmallow fabric reimagined with rich cable knit texture for an elevated look you'll want to live in all season long. \n\nFeatures\n● Signature Marshmallow Fabric with Cable Knit Texture\n● Relaxed 1/2 Zip Pullover featuring Trend-forward Funnel-neck\n● Flattering Tapered Pant Silhouette with Drawstring Waist\n● 28\" Inseam Tapered Pant with Drawstring Waist\n\nMaterials & Care\n● Easy care, colorfast, and machine washable\n● 100% Polyester\n● Retains its softness wash after wash\n\nBest For\n● Cozy mornings\n● Weekend lounging\n● Seasonal layering\n",
  tags: [],
  msrpDollars: 160,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:13.275Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
